(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[521],{

/***/ 9212:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(2872);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PageTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function PageTitle(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        className: "text-3xl font-extrabold leading-9 tracking-tight text-gray-900 dark:text-gray-100 sm:text-4xl sm:leading-10 md:text-5xl md:leading-14",
        children: children
    });
}


/***/ }),

/***/ 9829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$t": function() { return /* binding */ TagSEO; },
/* harmony export */   "TQ": function() { return /* binding */ PageSEO; },
/* harmony export */   "Uy": function() { return /* binding */ BlogSEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _data_siteMetadata__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1576);
/* harmony import */ var _data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3__);




const CommonSEO = (param)=>{
    let { title , description , ogType , ogImage , twImage  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "follow, index"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: "".concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl)).concat(router.asPath)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: ogType
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().title)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            typeof ogImage === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: ogImage
            }, ogImage) : ogImage.map((param)=>/*#__PURE__*/ {
                let { url  } = param;
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: url
                }, url);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().twitter)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: twImage
            })
        ]
    });
};
const PageSEO = (param)=>{
    let { title , description  } = param;
    const ogImageUrl = (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl) + (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().socialBanner);
    const twImageUrl = (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl) + (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().socialBanner);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CommonSEO, {
        title: title,
        description: description,
        ogType: "website",
        ogImage: ogImageUrl,
        twImage: twImageUrl
    });
};
const TagSEO = (param)=>{
    let { title , description  } = param;
    const ogImageUrl = (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl) + (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().socialBanner);
    const twImageUrl = (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl) + (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().socialBanner);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CommonSEO, {
                title: title,
                description: description,
                ogType: "website",
                ogImage: ogImageUrl,
                twImage: twImageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "alternate",
                    type: "application/rss+xml",
                    title: "".concat(description, " - RSS feed"),
                    href: "".concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl)).concat(router.asPath, "/feed.xml")
                })
            })
        ]
    });
};
const BlogSEO = (param)=>{
    let { title , summary , date , lastModified , url , images =[]  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const publishedAt = new Date(date).toISOString();
    const modifiedAt = new Date(lastModified || date).toISOString();
    let imagesArr = images.length === 0 ? [
        (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().socialBanner)
    ] : typeof images === "string" ? [
        images
    ] : images;
    const featuredImages = imagesArr.map((img)=>{
        return {
            "@type": "ImageObject",
            url: "".concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl)).concat(img)
        };
    });
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "Article",
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": url
        },
        headline: title,
        image: featuredImages,
        datePublished: publishedAt,
        dateModified: modifiedAt,
        author: (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().author),
        publisher: {
            "@type": "Organization",
            name: (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().author),
            logo: {
                "@type": "ImageObject",
                url: "".concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl)).concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteLogo))
            }
        },
        description: summary
    };
    const twImageUrl = featuredImages[0].url;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CommonSEO, {
                title: title,
                description: summary,
                ogType: "article",
                ogImage: featuredImages,
                twImage: twImageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    date && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "article:published_time",
                        content: publishedAt
                    }),
                    lastModified && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "article:modified_time",
                        content: modifiedAt
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "".concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl)).concat(router.asPath)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(structuredData, null, 2)
                        }
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 2872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ About; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./data/siteMetadata.js
var siteMetadata = __webpack_require__(1576);
var siteMetadata_default = /*#__PURE__*/__webpack_require__.n(siteMetadata);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/SocialIcon/mail.svg
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgMail(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
  })));
}

/* harmony default export */ var mail = (SvgMail);
;// CONCATENATED MODULE: ./components/SocialIcon/github.svg
var github_path;

function github_extends() { github_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return github_extends.apply(this, arguments); }



function SvgGithub(props) {
  return /*#__PURE__*/react.createElement("svg", github_extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), github_path || (github_path = /*#__PURE__*/react.createElement("path", {
    d: "M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"
  })));
}

/* harmony default export */ var github = (SvgGithub);
;// CONCATENATED MODULE: ./components/SocialIcon/linkedin.svg
var linkedin_path;

function linkedin_extends() { linkedin_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return linkedin_extends.apply(this, arguments); }



function SvgLinkedin(props) {
  return /*#__PURE__*/react.createElement("svg", linkedin_extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), linkedin_path || (linkedin_path = /*#__PURE__*/react.createElement("path", {
    d: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
  })));
}

/* harmony default export */ var linkedin = (SvgLinkedin);
;// CONCATENATED MODULE: ./components/SocialIcon/twitter.svg
var twitter_path;

function twitter_extends() { twitter_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return twitter_extends.apply(this, arguments); }



function SvgTwitter(props) {
  return /*#__PURE__*/react.createElement("svg", twitter_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), twitter_path || (twitter_path = /*#__PURE__*/react.createElement("path", {
    d: "M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"
  })));
}

/* harmony default export */ var twitter = (SvgTwitter);
;// CONCATENATED MODULE: ./components/SocialIcon/codepen.svg
var codepen_path;

function codepen_extends() { codepen_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return codepen_extends.apply(this, arguments); }



function SvgCodepen(props) {
  return /*#__PURE__*/react.createElement("svg", codepen_extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), codepen_path || (codepen_path = /*#__PURE__*/react.createElement("path", {
    d: "M18.144 13.067v-2.134L16.55 12zm1.276 1.194a.628.628 0 01-.006.083l-.005.028-.011.053-.01.031a.443.443 0 01-.017.047l-.014.03a.78.78 0 01-.021.043l-.019.03a.57.57 0 01-.08.1l-.026.025a.602.602 0 01-.036.03l-.029.022-.01.008-6.782 4.522a.637.637 0 01-.708 0L4.864 14.79l-.01-.008a.599.599 0 01-.065-.052l-.026-.025-.032-.034-.021-.028a.588.588 0 01-.067-.11l-.014-.031a.644.644 0 01-.017-.047l-.01-.03c-.004-.018-.008-.036-.01-.054l-.006-.028a.628.628 0 01-.006-.083V9.739a.58.58 0 01.006-.083l.005-.027.011-.054.01-.03a.574.574 0 01.12-.217l.031-.034.026-.025a.62.62 0 01.065-.052l.01-.008 6.782-4.521a.638.638 0 01.708 0l6.782 4.521.01.008.03.022.035.03c.01.008.017.016.026.025a.545.545 0 01.08.1l.019.03a.633.633 0 01.021.043l.014.03c.007.016.012.032.017.047l.01.031c.004.018.008.036.01.054l.006.027a.619.619 0 01.006.083zM12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.372 12-12 0-6.627-5.372-12-12-12m0 10.492L9.745 12 12 13.51 14.255 12zm.638 4.124v2.975l4.996-3.33-2.232-1.493zm-6.272-.356l4.996 3.33v-2.974l-2.764-1.849zm11.268-4.52l-4.996-3.33v2.974l2.764 1.85zm-6.272-.356V6.41L6.366 9.74l2.232 1.493zm-5.506 1.549v2.134L7.45 12z"
  })));
}

/* harmony default export */ var codepen = (SvgCodepen);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/SocialIcon/index.tsx
// Icons taken from: https://simpleicons.org/







const components = {
    mail: mail,
    github: github,
    linkedin: linkedin,
    twitter: twitter,
    codepen: codepen
};
const SocialIcon = (param)=>{
    let { kind , href , size =8  } = param;
    if (!href) return null;
    const SocialSvg = components[kind];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        className: "text-sm text-gray-500 transition hover:text-gray-600",
        target: "_blank",
        rel: "noopener noreferrer",
        href: href,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: kind
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialSvg, {
                className: "fill-current text-gray-700 dark:text-gray-200 hover:text-primary-500 dark:hover:text-primary-400 h-".concat(size, " w-").concat(size)
            })
        ]
    });
};
/* harmony default export */ var components_SocialIcon = (SocialIcon);

// EXTERNAL MODULE: ./components/SEO.tsx
var SEO = __webpack_require__(9829);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/PageTitle.tsx
var PageTitle = __webpack_require__(2866);
;// CONCATENATED MODULE: ./node_modules/datocms-structured-text-utils/dist/esm/definitions.js
var _a, _b;
var blockquoteNodeType = 'blockquote';
var blockNodeType = 'block';
var codeNodeType = 'code';
var headingNodeType = 'heading';
var inlineItemNodeType = 'inlineItem';
var itemLinkNodeType = 'itemLink';
var linkNodeType = 'link';
var listItemNodeType = 'listItem';
var listNodeType = 'list';
var paragraphNodeType = 'paragraph';
var rootNodeType = 'root';
var spanNodeType = 'span';
var thematicBreakNodeType = 'thematicBreak';
var allowedNodeTypes = [
    blockquoteNodeType,
    blockNodeType,
    codeNodeType,
    headingNodeType,
    inlineItemNodeType,
    itemLinkNodeType,
    linkNodeType,
    listItemNodeType,
    listNodeType,
    paragraphNodeType,
    rootNodeType,
    spanNodeType,
    thematicBreakNodeType,
];
var allowedChildren = (_a = {},
    _a[blockquoteNodeType] = [paragraphNodeType],
    _a[blockNodeType] = [],
    _a[codeNodeType] = [],
    _a[headingNodeType] = 'inlineNodes',
    _a[inlineItemNodeType] = [],
    _a[itemLinkNodeType] = 'inlineNodes',
    _a[linkNodeType] = 'inlineNodes',
    _a[listItemNodeType] = [paragraphNodeType, listNodeType],
    _a[listNodeType] = [listItemNodeType],
    _a[paragraphNodeType] = 'inlineNodes',
    _a[rootNodeType] = [
        blockquoteNodeType,
        codeNodeType,
        listNodeType,
        paragraphNodeType,
        headingNodeType,
        blockNodeType,
        thematicBreakNodeType,
    ],
    _a[spanNodeType] = [],
    _a[thematicBreakNodeType] = [],
    _a);
var definitions_inlineNodeTypes = [
    spanNodeType,
    linkNodeType,
    itemLinkNodeType,
    inlineItemNodeType,
];
var allowedAttributes = (_b = {},
    _b[blockquoteNodeType] = ['children', 'attribution'],
    _b[blockNodeType] = ['item'],
    _b[codeNodeType] = ['language', 'highlight', 'code'],
    _b[headingNodeType] = ['level', 'children'],
    _b[inlineItemNodeType] = ['item'],
    _b[itemLinkNodeType] = ['item', 'children', 'meta'],
    _b[linkNodeType] = ['url', 'children', 'meta'],
    _b[listItemNodeType] = ['children'],
    _b[listNodeType] = ['style', 'children'],
    _b[paragraphNodeType] = ['children'],
    _b[rootNodeType] = ['children'],
    _b[spanNodeType] = ['value', 'marks'],
    _b[thematicBreakNodeType] = [],
    _b);
var allowedMarks = (/* unused pure expression or super */ null && ([
    'strong',
    'code',
    'emphasis',
    'underline',
    'strikethrough',
    'highlight',
]));
//# sourceMappingURL=definitions.js.map
;// CONCATENATED MODULE: ./node_modules/datocms-structured-text-utils/dist/esm/guards.js

function hasChildren(node) {
    return 'children' in node;
}
function isInlineNode(node) {
    return inlineNodeTypes.includes(node.type);
}
function isHeading(node) {
    return node.type === headingNodeType;
}
function isSpan(node) {
    return node.type === spanNodeType;
}
function isRoot(node) {
    return node.type === rootNodeType;
}
function isParagraph(node) {
    return node.type === paragraphNodeType;
}
function isList(node) {
    return node.type === listNodeType;
}
function isListItem(node) {
    return node.type === listItemNodeType;
}
function isBlockquote(node) {
    return node.type === blockquoteNodeType;
}
function isBlock(node) {
    return node.type === blockNodeType;
}
function isCode(node) {
    return node.type === codeNodeType;
}
function isLink(node) {
    return node.type === linkNodeType;
}
function isItemLink(node) {
    return node.type === itemLinkNodeType;
}
function isInlineItem(node) {
    return node.type === inlineItemNodeType;
}
function isThematicBreak(node) {
    return node.type === thematicBreakNodeType;
}
function isStructuredText(
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
obj) {
    return obj && 'value' in obj && isDocument(obj.value);
}
function isDocument(
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
obj) {
    return obj && 'schema' in obj && 'document' in obj;
}
//# sourceMappingURL=guards.js.map
;// CONCATENATED MODULE: ./node_modules/datocms-structured-text-utils/node_modules/array-flatten/dist.es2015/index.js
/**
 * Flatten an array indefinitely.
 */
function flatten(array) {
    var result = [];
    $flatten(array, result);
    return result;
}
/**
 * Internal flatten function recursively passes `result`.
 */
function $flatten(array, result) {
    for (var i = 0; i < array.length; i++) {
        var value = array[i];
        if (Array.isArray(value)) {
            $flatten(value, result);
        }
        else {
            result.push(value);
        }
    }
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/datocms-structured-text-utils/dist/esm/render.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};


var RenderError = /** @class */ (function (_super) {
    __extends(RenderError, _super);
    function RenderError(message, node) {
        var _this = _super.call(this, message) || this;
        _this.node = node;
        Object.setPrototypeOf(_this, RenderError.prototype);
        return _this;
    }
    return RenderError;
}(Error));

var renderRule = function (guard, transform) { return ({
    appliable: guard,
    apply: function (ctx) {
        return transform(ctx);
    },
}); };
function transformNode(adapter, node, key, ancestors, renderRules) {
    var children = hasChildren(node)
        ? flatten(node.children
            .map(function (innerNode, index) {
            return transformNode(adapter, innerNode, "t-" + index, __spreadArrays([node], ancestors), renderRules);
        })
            .filter(function (x) { return !!x; }))
        : undefined;
    var matchingTransform = renderRules.find(function (transform) {
        return transform.appliable(node);
    });
    if (matchingTransform) {
        return matchingTransform.apply({ adapter: adapter, node: node, children: children, key: key, ancestors: ancestors });
    }
    else {
        throw new RenderError("Don't know how to render a node with type \"" + node.type + "\". Please specify a custom renderRule for it!", node);
    }
}
function render(adapter, structuredTextOrNode, renderRules) {
    if (!structuredTextOrNode) {
        return null;
    }
    var result = transformNode(adapter, isStructuredText(structuredTextOrNode)
        ? structuredTextOrNode.value.document
        : isDocument(structuredTextOrNode)
            ? structuredTextOrNode.document
            : structuredTextOrNode, 't-0', [], renderRules);
    return result;
}
//# sourceMappingURL=render.js.map
;// CONCATENATED MODULE: ./node_modules/datocms-structured-text-generic-html-renderer/dist/esm/index.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var esm_spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};


function markToTagName(mark) {
    switch (mark) {
        case 'emphasis':
            return 'em';
        case 'underline':
            return 'u';
        case 'strikethrough':
            return 'del';
        case 'highlight':
            return 'mark';
        default:
            return mark;
    }
}
var defaultMetaTransformer = function (_a) {
    var meta = _a.meta;
    var attributes = {};
    meta.forEach(function (entry) {
        if (['target', 'title', 'rel'].includes(entry.id)) {
            attributes[entry.id] = entry.value;
        }
    });
    return attributes;
};
function esm_render(adapter, structuredTextOrNode, customRules, metaTransformer) {
    if (metaTransformer === void 0) { metaTransformer = defaultMetaTransformer; }
    return render(adapter, structuredTextOrNode, esm_spreadArrays(customRules, [
        renderRule(isRoot, function (_a) {
            var renderFragment = _a.adapter.renderFragment, key = _a.key, children = _a.children;
            return renderFragment(children, key);
        }),
        renderRule(isParagraph, function (_a) {
            var renderNode = _a.adapter.renderNode, key = _a.key, children = _a.children;
            return renderNode('p', { key: key }, children);
        }),
        renderRule(isList, function (_a) {
            var renderNode = _a.adapter.renderNode, node = _a.node, key = _a.key, children = _a.children;
            return renderNode(node.style === 'bulleted' ? 'ul' : 'ol', { key: key }, children);
        }),
        renderRule(isListItem, function (_a) {
            var renderNode = _a.adapter.renderNode, key = _a.key, children = _a.children;
            return renderNode('li', { key: key }, children);
        }),
        renderRule(isBlockquote, function (_a) {
            var renderNode = _a.adapter.renderNode, key = _a.key, node = _a.node, children = _a.children;
            var childrenWithAttribution = node.attribution
                ? esm_spreadArrays((children || []), [
                    renderNode("footer", { key: 'footer' }, node.attribution),
                ]) : children;
            return renderNode('blockquote', { key: key }, childrenWithAttribution);
        }),
        renderRule(isCode, function (_a) {
            var _b = _a.adapter, renderNode = _b.renderNode, renderText = _b.renderText, key = _a.key, node = _a.node;
            return renderNode('pre', { key: key, 'data-language': node.language }, renderNode('code', null, renderText(node.code)));
        }),
        renderRule(isLink, function (_a) {
            var renderNode = _a.adapter.renderNode, key = _a.key, children = _a.children, node = _a.node;
            var meta = node.meta ? metaTransformer({ node: node, meta: node.meta }) : {};
            return renderNode('a', __assign(__assign({}, (meta || {})), { key: key, href: node.url }), children);
        }),
        renderRule(isThematicBreak, function (_a) {
            var renderNode = _a.adapter.renderNode, key = _a.key;
            return renderNode('hr', { key: key });
        }),
        renderRule(isHeading, function (_a) {
            var node = _a.node, renderNode = _a.adapter.renderNode, children = _a.children, key = _a.key;
            return renderNode("h" + node.level, { key: key }, children);
        }),
        renderRule(isSpan, function (_a) {
            var _b = _a.adapter, renderNode = _b.renderNode, renderText = _b.renderText, key = _a.key, node = _a.node;
            var marks = node.marks || [];
            var lines = node.value.split(/\n/);
            var textWithNewlinesConvertedToBr = lines.length > 0
                ? lines.slice(1).reduce(function (acc, line, index) {
                    return acc.concat([
                        renderNode('br', { key: key + "-br-" + index }),
                        renderText(line, key + "-line-" + index),
                    ]);
                }, [renderText(lines[0], key + "-line-first")])
                : renderText(node.value, key);
            return marks.reduce(function (children, mark) {
                return renderNode(markToTagName(mark), { key: key }, children);
            }, textWithNewlinesConvertedToBr);
        }),
    ]));
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/react-datocms/dist/esm/StructuredText/index.js




var defaultAdapter = {
    renderNode: react.createElement,
    renderFragment: function (children, key) { return react.createElement(react.Fragment, { key: key }, children); },
    renderText: function (text, key) { return text; }
};
function appendKeyToValidElement(element, key) {
    if ((0,react.isValidElement)(element) && element.key === null) {
        return (0,react.cloneElement)(element, { key: key });
    }
    return element;
}
function StructuredText(_a) {
    var data = _a.data, renderInlineRecord = _a.renderInlineRecord, renderLinkToRecord = _a.renderLinkToRecord, renderBlock = _a.renderBlock, renderText = _a.renderText, renderNode = _a.renderNode, renderFragment = _a.renderFragment, customRules = _a.customRules, metaTransformer = _a.metaTransformer;
    var result = esm_render({
        renderText: renderText || defaultAdapter.renderText,
        renderNode: renderNode || defaultAdapter.renderNode,
        renderFragment: renderFragment || defaultAdapter.renderFragment
    }, data, [
        renderRule(isInlineItem, function (_a) {
            var node = _a.node, key = _a.key;
            if (!renderInlineRecord) {
                throw new RenderError("The Structured Text document contains an 'inlineItem' node, but no 'renderInlineRecord' prop is specified!", node);
            }
            if (!isStructuredText(data) || !data.links) {
                throw new RenderError("The document contains an 'itemLink' node, but the passed data prop is not a Structured Text GraphQL response, or data.links is not present!", node);
            }
            var item = data.links.find(function (item) { return item.id === node.item; });
            if (!item) {
                throw new RenderError("The Structured Text document contains an 'inlineItem' node, but cannot find a record with ID " + node.item + " inside data.links!", node);
            }
            return appendKeyToValidElement(renderInlineRecord({ record: item }), key);
        }),
        renderRule(isItemLink, function (_a) {
            var node = _a.node, key = _a.key, children = _a.children;
            if (!renderLinkToRecord) {
                throw new RenderError("The Structured Text document contains an 'itemLink' node, but no 'renderLinkToRecord' prop is specified!", node);
            }
            if (!isStructuredText(data) || !data.links) {
                throw new RenderError("The document contains an 'itemLink' node, but the passed data prop is not a Structured Text GraphQL response, or data.links is not present!", node);
            }
            var item = data.links.find(function (item) { return item.id === node.item; });
            if (!item) {
                throw new RenderError("The Structured Text document contains an 'itemLink' node, but cannot find a record with ID " + node.item + " inside data.links!", node);
            }
            return appendKeyToValidElement(renderLinkToRecord({
                record: item,
                children: children,
                transformedMeta: node.meta
                    ? (metaTransformer || defaultMetaTransformer)({
                        node: node,
                        meta: node.meta
                    })
                    : null
            }), key);
        }),
        renderRule(isBlock, function (_a) {
            var node = _a.node, key = _a.key;
            if (!renderBlock) {
                throw new RenderError("The Structured Text document contains a 'block' node, but no 'renderBlock' prop is specified!", node);
            }
            if (!isStructuredText(data) || !data.blocks) {
                throw new RenderError("The document contains an 'block' node, but the passed data prop is not a Structured Text GraphQL response, or data.blocks is not present!", node);
            }
            var item = data.blocks.find(function (item) { return item.id === node.item; });
            if (!item) {
                throw new RenderError("The Structured Text document contains a 'block' node, but cannot find a record with ID " + node.item + " inside data.blocks!", node);
            }
            return appendKeyToValidElement(renderBlock({ record: item }), key);
        }),
    ].concat(customRules || []), metaTransformer);
    return result;
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./components/CustomLink.tsx
var CustomLink = __webpack_require__(7896);
;// CONCATENATED MODULE: ./pages/about.tsx









var __N_SSG = true;
function About(param) {
    let { about  } = param;
    const { name , title , profilepicture , content , updatedAt  } = about;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* PageSEO */.TQ, {
                title: "About - ".concat((siteMetadata_default()).author),
                description: "About me - ".concat((siteMetadata_default()).author)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pt-6 pb-8 space-y-2 md:space-y-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle/* default */.Z, {
                    children: "About"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "items-start space-y-2 xl:grid xl:grid-cols-3 xl:gap-x-8 xl:space-y-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center xl:items-start pt-8 xl:sticky xl:top-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: profilepicture.url,
                                width: 192,
                                height: 192,
                                alt: profilepicture.alt,
                                className: "rounded-full xl:rounded-lg",
                                placeholder: "blur",
                                blurDataURL: profilepicture.blurUpThumb
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "pt-4 pb-2 text-2xl font-bold leading-8 tracking-tight",
                                children: name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-gray-500 dark:text-gray-400",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex pt-6 space-x-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SocialIcon, {
                                        kind: "mail",
                                        href: "mailto:".concat((siteMetadata_default()).email)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SocialIcon, {
                                        kind: "github",
                                        href: (siteMetadata_default()).github
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SocialIcon, {
                                        kind: "codepen",
                                        href: (siteMetadata_default()).codepen
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SocialIcon, {
                                        kind: "twitter",
                                        href: (siteMetadata_default()).twitter
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pt-8 pb-8 prose dark:prose-dark max-w-none xl:col-span-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredText, {
                                data: content,
                                customRules: [
                                    renderRule(isLink, (param)=>/*#__PURE__*/ {
                                        let { node  } = param;
                                        return (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                            href: node.url,
                                            children: node.children.map((child)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(child.type, {
                                                    children: child.value
                                                }, child.value);
                                            })
                                        });
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-14",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-gray-300 dark:text-gray-700",
                                    children: [
                                        "Last updated at",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                            dateTime: updatedAt,
                                            children: new Date(updatedAt).toLocaleDateString((siteMetadata_default()).locale, {
                                                year: "numeric",
                                                month: "long",
                                                day: "numeric"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,774,888,179], function() { return __webpack_exec__(9212); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);